import { MessageOperationRequest, RequestOperationRequest, TransportOperation } from '@peercolab/engine'
import { SearchInput } from '../../Main/Model/1_0_Initial/Core/PathItems'
import { SearchSpeciesOutput, UpdateSpeciesThumbnailInput, AddBreedInput, UpdateBreedNameInput, MoveBreedInput, UpdateTrainerSignatureInput, AddPredefinedTaskSpeciesInput, UpdatePredefinedTaskSpeciesInput, RemovePredefinedTaskSpeciesInput, SearchCoursesInput, SearchCoursesOutput, AddModuleInput, RemoveModuleInput, UpdateModuleNameInput, UpdateModuleDescriptionInput, MoveMaterialRequirementsInput, MoveMaterialStepsInput, MoveMaterialQuestionsInput, SearchTranslationKeysInput, SearchTranslationKeysOutput, PublishChangesInput, RevertChangesInput, PublishAllChangesInput, RevertAllChangesInput, GetLanguageFilesInput, GetLanguageFilesOutput } from '../../Main/Model/1_0_Initial/PathItems'
import { CreateSpeciesInput, Species, UpdateSpeciesNameInput, UpdateSpeciesDescriptionInput, UpdateSpeciesUtilizesCommandsInput, UpdateSpeciesStateInput, UpdateSpeciesUsesLitterBoxInput, UpdateSpeciesIsIndoorOutdoorPetInput } from '../../Main/Model/1_0_Initial/Backoffice/Species/PathItems'
import { Command, CreateCommandInput, UpdateCommandDescriptionInput, UpdateCommandNameInput, UpdateCommandStateInput } from '../../Main/Model/1_0_Initial/Backoffice/Commands/PathItems'
import { CreateCourseCategoryInput, CourseCategory, UpdateCourseCategoryNameInput, UpdateCourseCategoryStateInput } from '../../Main/Model/1_0_Initial/Backoffice/Training/Categories/PathItems'
import { CreateTrainerInput, Trainer, UpdateTrainerNameInput, UpdateTrainerDescriptionInput, UpdateTrainerExperienceInYearsInput, UpdateTrainerThumbnailInput, UpdateTrainerStateInput } from '../../Main/Model/1_0_Initial/Backoffice/Trainers/PathItems'
import { CreateHealthCheckItemInput, HealthCheckItem, UpdateHealthCheckItemNameInput, UpdateHealthCheckItemStateInput } from '../../Main/Model/1_0_Initial/Backoffice/Health/PathItems'
import { CreateInsuranceProviderInput, InsuranceProvider, UpdateInsuranceProviderNameInput, UpdateInsuranceProviderStateInput } from '../../Main/Model/1_0_Initial/Backoffice/InsuranceProviders/PathItems'
import { CreateSportInput, Sport, UpdateSportNameInput, UpdateSportStateInput } from '../../Main/Model/1_0_Initial/Backoffice/Sports/PathItems'
import { CreatePredefinedTaskInput, PredefinedTask, UpdatePredefinedTaskTypeInput, UpdatePredefinedTaskNameInput, UpdatePredefinedTaskIconInput, UpdatePredefinedTaskSuggestedRRULEInput, UpdatePredefinedTaskStateInput } from '../../Main/Model/1_0_Initial/Backoffice/Tasks/PathItems'
import { CreateCourseInput, Course, UpdateCourseTypeInput, UpdateCourseSpeciesIdInput, UpdateCourseBreedIdsInput, UpdateCourseNameInput, UpdateCourseThumbnailUrlInput, UpdateCourseVideoUrlInput, UpdateCourseDurationInput, UpdateCourseDescriptionInput, UpdateCourseTrainerIdInput, UpdateCourseLongDescriptionInput, UpdateCourseCategoriesInput, UpdateCourseSequentialCompletionInput, UpdateCoursePaymentProductIdInput, UpdateCourseStateInput } from '../../Main/Model/1_0_Initial/Backoffice/Training/Courses/PathItems'
import { CreateLessonInput, Lesson, UpdateLessonNameInput, UpdateLessonThumbnailUrlInput, UpdateLessonVideoUrlInput, UpdateLessonDescriptionInput, UpdateLessonLongDescriptionInput, UpdateLessonDurationInput, MaterialRequirementValues, MaterialRequirement, MaterialStepValues, MaterialStep, MaterialQuestionValues, MaterialQuestion, UpdateLessonMinimumNumberOfCorrectAnswersInput } from '../../Main/Model/1_0_Initial/Backoffice/Training/Courses/Lessons/PathItems'
import { TranslationKeyPair, Language, MultipleTranslationKeyPairs } from '../../Main/Model/1_0_Initial/Backoffice/Translations/PathItems'

export class SpeciesManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.SearchSpecies\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    query: string\n    limit: int\n    offset: int\n\n  Output(isArray = true)):\n    id: Guid\n    name: string\n    numberOfBreeds: int\n    publishedBreeds: int\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.CreateSpecies\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    speciesId?: Guid\n    name: string\n    description?: string\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    description: string\n    thumbnail?:\n      url: string\n    utilizesCommands: boolean\n    usesLitterBox: boolean\n    isIndoorOutdoorPet: boolean\n    breeds[]:\n      sortId: int\n      breed:\n        id: Guid\n        speciesId: Guid\n        name: string\n        translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.GetSpecies\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    description: string\n    thumbnail?:\n      url: string\n    utilizesCommands: boolean\n    usesLitterBox: boolean\n    isIndoorOutdoorPet: boolean\n    breeds[]:\n      sortId: int\n      breed:\n        id: Guid\n        speciesId: Guid\n        name: string\n        translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.DeleteSpecies\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesName\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesDescription\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesThumbnail\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    image?:\n      filename: string\n      size: int\n      width?: int\n      height?: int\n      mimeType: string\n      duration?: int\n      base64Content: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesUtilizesCommands\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    utilizesCommands: boolean\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesState\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.AddBreed\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: ADD\n  Type: message\n  Input(isArray = false):\n    breedId?: Guid\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.RemoveBreed\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: REMOVE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.UpdateBreedName\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.MoveBreed\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    moveInstruction:\n      # Valid values: up, down, top, bottom, toposition\n      moveDirection: string\n      position?: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesUsesLitterBox\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    usesLitterBox: boolean\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesIsIndoorOutdoorPet\n  UsageId: PetKey.BackofficeFE.Client.SpeciesManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    isIndoorOutdoorPet: boolean\n\n  Output:\n    {}\n'
  }

  public static searchSpecies(input: SearchInput): RequestOperationRequest<SearchInput,SearchSpeciesOutput[]> {
    return new RequestOperationRequest<SearchInput,SearchSpeciesOutput[]>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<SearchInput,SearchSpeciesOutput[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.SearchSpecies",
        "SEARCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createSpecies(input: CreateSpeciesInput): RequestOperationRequest<CreateSpeciesInput,Species> {
    return new RequestOperationRequest<CreateSpeciesInput,Species>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<CreateSpeciesInput,Species>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.CreateSpecies",
        "CREATE",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getSpecies(): RequestOperationRequest<object,Species> {
    return new RequestOperationRequest<object,Species>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<object,Species>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.GetSpecies",
        "GET",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static deleteSpecies(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.DeleteSpecies",
        "DELETE",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateSpeciesName(input: UpdateSpeciesNameInput): MessageOperationRequest<UpdateSpeciesNameInput> {
    return new MessageOperationRequest<UpdateSpeciesNameInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateSpeciesNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesName",
        "PATCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateSpeciesDescription(input: UpdateSpeciesDescriptionInput): MessageOperationRequest<UpdateSpeciesDescriptionInput> {
    return new MessageOperationRequest<UpdateSpeciesDescriptionInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateSpeciesDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesDescription",
        "PATCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateSpeciesThumbnail(input: UpdateSpeciesThumbnailInput): MessageOperationRequest<UpdateSpeciesThumbnailInput> {
    return new MessageOperationRequest<UpdateSpeciesThumbnailInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateSpeciesThumbnailInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesThumbnail",
        "PATCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateSpeciesUtilizesCommands(input: UpdateSpeciesUtilizesCommandsInput): MessageOperationRequest<UpdateSpeciesUtilizesCommandsInput> {
    return new MessageOperationRequest<UpdateSpeciesUtilizesCommandsInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateSpeciesUtilizesCommandsInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesUtilizesCommands",
        "PATCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateSpeciesState(input: UpdateSpeciesStateInput): MessageOperationRequest<UpdateSpeciesStateInput> {
    return new MessageOperationRequest<UpdateSpeciesStateInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateSpeciesStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesState",
        "PATCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static addBreed(input: AddBreedInput): MessageOperationRequest<AddBreedInput> {
    return new MessageOperationRequest<AddBreedInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<AddBreedInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.AddBreed",
        "ADD",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static removeBreed(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.RemoveBreed",
        "REMOVE",
        ["BreedId", "SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateBreedName(input: UpdateBreedNameInput): MessageOperationRequest<UpdateBreedNameInput> {
    return new MessageOperationRequest<UpdateBreedNameInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateBreedNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.UpdateBreedName",
        "PATCH",
        ["BreedId", "SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static moveBreed(input: MoveBreedInput): MessageOperationRequest<MoveBreedInput> {
    return new MessageOperationRequest<MoveBreedInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<MoveBreedInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.MoveBreed",
        "PATCH",
        ["BreedId", "SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateSpeciesUsesLitterBox(input: UpdateSpeciesUsesLitterBoxInput): MessageOperationRequest<UpdateSpeciesUsesLitterBoxInput> {
    return new MessageOperationRequest<UpdateSpeciesUsesLitterBoxInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateSpeciesUsesLitterBoxInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesUsesLitterBox",
        "PATCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateSpeciesIsIndoorOutdoorPet(input: UpdateSpeciesIsIndoorOutdoorPetInput): MessageOperationRequest<UpdateSpeciesIsIndoorOutdoorPetInput> {
    return new MessageOperationRequest<UpdateSpeciesIsIndoorOutdoorPetInput>(
      "PetKey.BackofficeFE.Client.SpeciesManagement",
      new TransportOperation<UpdateSpeciesIsIndoorOutdoorPetInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.UpdateSpeciesIsIndoorOutdoorPet",
        "PATCH",
        ["SpeciesId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class BaseCommandManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Commands.SearchCommand\n  UsageId: PetKey.BackofficeFE.Client.BaseCommandManagement\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    query: string\n    limit: int\n    offset: int\n\n  Output(isArray = true)):\n    id: Guid\n    name: string\n    translationKey: string\n    description: string\n    descriptionTranslationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Commands.CreateCommand\n  UsageId: PetKey.BackofficeFE.Client.BaseCommandManagement\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    commandId?: Guid\n    name: string\n    description?: string\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    description: string\n    descriptionTranslationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Commands.DeleteCommand\n  UsageId: PetKey.BackofficeFE.Client.BaseCommandManagement\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandDescription\n  UsageId: PetKey.BackofficeFE.Client.BaseCommandManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandName\n  UsageId: PetKey.BackofficeFE.Client.BaseCommandManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Commands.GetCommand\n  UsageId: PetKey.BackofficeFE.Client.BaseCommandManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    description: string\n    descriptionTranslationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandState\n  UsageId: PetKey.BackofficeFE.Client.BaseCommandManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\n'
  }

  public static searchCommand(input: SearchInput): RequestOperationRequest<SearchInput,Command[]> {
    return new RequestOperationRequest<SearchInput,Command[]>(
      "PetKey.BackofficeFE.Client.BaseCommandManagement",
      new TransportOperation<SearchInput,Command[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.SearchCommand",
        "SEARCH",
        ["CommandId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createCommand(input: CreateCommandInput): RequestOperationRequest<CreateCommandInput,Command> {
    return new RequestOperationRequest<CreateCommandInput,Command>(
      "PetKey.BackofficeFE.Client.BaseCommandManagement",
      new TransportOperation<CreateCommandInput,Command>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.CreateCommand",
        "CREATE",
        ["CommandId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static deleteCommand(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.BaseCommandManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.DeleteCommand",
        "DELETE",
        ["CommandId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateCommandDescription(input: UpdateCommandDescriptionInput): MessageOperationRequest<UpdateCommandDescriptionInput> {
    return new MessageOperationRequest<UpdateCommandDescriptionInput>(
      "PetKey.BackofficeFE.Client.BaseCommandManagement",
      new TransportOperation<UpdateCommandDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandDescription",
        "PATCH",
        ["CommandId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCommandName(input: UpdateCommandNameInput): MessageOperationRequest<UpdateCommandNameInput> {
    return new MessageOperationRequest<UpdateCommandNameInput>(
      "PetKey.BackofficeFE.Client.BaseCommandManagement",
      new TransportOperation<UpdateCommandNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandName",
        "PATCH",
        ["CommandId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getCommand(): RequestOperationRequest<object,Command> {
    return new RequestOperationRequest<object,Command>(
      "PetKey.BackofficeFE.Client.BaseCommandManagement",
      new TransportOperation<object,Command>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.GetCommand",
        "GET",
        ["CommandId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateCommandState(input: UpdateCommandStateInput): MessageOperationRequest<UpdateCommandStateInput> {
    return new MessageOperationRequest<UpdateCommandStateInput>(
      "PetKey.BackofficeFE.Client.BaseCommandManagement",
      new TransportOperation<UpdateCommandStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandState",
        "PATCH",
        ["CommandId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class CourseCategoryManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.CreateCourseCategory\n  UsageId: PetKey.BackofficeFE.Client.CourseCategoryManagement\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    courseCategoryId?: Guid\n    name: string\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.GetAllCourseCategorys\n  UsageId: PetKey.BackofficeFE.Client.CourseCategoryManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = true)):\n    id: Guid\n    name: string\n    translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.DeleteCourseCategory\n  UsageId: PetKey.BackofficeFE.Client.CourseCategoryManagement\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.UpdateCourseCategoryName\n  UsageId: PetKey.BackofficeFE.Client.CourseCategoryManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.UpdateCourseCategoryState\n  UsageId: PetKey.BackofficeFE.Client.CourseCategoryManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\n'
  }

  public static createCourseCategory(input: CreateCourseCategoryInput): RequestOperationRequest<CreateCourseCategoryInput,CourseCategory> {
    return new RequestOperationRequest<CreateCourseCategoryInput,CourseCategory>(
      "PetKey.BackofficeFE.Client.CourseCategoryManagement",
      new TransportOperation<CreateCourseCategoryInput,CourseCategory>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.CreateCourseCategory",
        "CREATE",
        ["CourseCategoryId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getAllCourseCategorys(): RequestOperationRequest<object,CourseCategory[]> {
    return new RequestOperationRequest<object,CourseCategory[]>(
      "PetKey.BackofficeFE.Client.CourseCategoryManagement",
      new TransportOperation<object,CourseCategory[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.GetAllCourseCategorys",
        "GET",
        ["CourseCategoryId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static deleteCourseCategory(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.CourseCategoryManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.DeleteCourseCategory",
        "DELETE",
        ["CourseCategoryId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateCourseCategoryName(input: UpdateCourseCategoryNameInput): MessageOperationRequest<UpdateCourseCategoryNameInput> {
    return new MessageOperationRequest<UpdateCourseCategoryNameInput>(
      "PetKey.BackofficeFE.Client.CourseCategoryManagement",
      new TransportOperation<UpdateCourseCategoryNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.UpdateCourseCategoryName",
        "PATCH",
        ["CourseCategoryId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseCategoryState(input: UpdateCourseCategoryStateInput): MessageOperationRequest<UpdateCourseCategoryStateInput> {
    return new MessageOperationRequest<UpdateCourseCategoryStateInput>(
      "PetKey.BackofficeFE.Client.CourseCategoryManagement",
      new TransportOperation<UpdateCourseCategoryStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Categories.UpdateCourseCategoryState",
        "PATCH",
        ["CourseCategoryId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class TrainerManagment {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.CreateTrainer\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    trainerId?: Guid\n    name: string\n    description?: string\n    experienceInYears?: int\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    description: string\n    experienceInYears: int\n    thumbnail?:\n      url: string\n    signature?:\n      url: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.SearchTrainer\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    query: string\n    limit: int\n    offset: int\n\n  Output(isArray = true)):\n    id: Guid\n    name: string\n    description: string\n    experienceInYears: int\n    thumbnail?:\n      url: string\n    signature?:\n      url: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.DeleteTrainer\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerName\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerDescription\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerExperienceInYears\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    experienceInYears: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerThumbnail\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    image?:\n      filename: string\n      size: int\n      width?: int\n      height?: int\n      mimeType: string\n      duration?: int\n      base64Content: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.GetTrainer\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    description: string\n    experienceInYears: int\n    thumbnail?:\n      url: string\n    signature?:\n      url: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerState\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerSignature\n  UsageId: PetKey.BackofficeFE.Client.TrainerManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    image?:\n      filename: string\n      size: int\n      width?: int\n      height?: int\n      mimeType: string\n      duration?: int\n      base64Content: string\n\n  Output:\n    {}\n'
  }

  public static createTrainer(input: CreateTrainerInput): RequestOperationRequest<CreateTrainerInput,Trainer> {
    return new RequestOperationRequest<CreateTrainerInput,Trainer>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<CreateTrainerInput,Trainer>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.CreateTrainer",
        "CREATE",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static searchTrainer(input: SearchInput): RequestOperationRequest<SearchInput,Trainer[]> {
    return new RequestOperationRequest<SearchInput,Trainer[]>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<SearchInput,Trainer[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.SearchTrainer",
        "SEARCH",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static deleteTrainer(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.DeleteTrainer",
        "DELETE",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateTrainerName(input: UpdateTrainerNameInput): MessageOperationRequest<UpdateTrainerNameInput> {
    return new MessageOperationRequest<UpdateTrainerNameInput>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<UpdateTrainerNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerName",
        "PATCH",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateTrainerDescription(input: UpdateTrainerDescriptionInput): MessageOperationRequest<UpdateTrainerDescriptionInput> {
    return new MessageOperationRequest<UpdateTrainerDescriptionInput>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<UpdateTrainerDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerDescription",
        "PATCH",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateTrainerExperienceInYears(input: UpdateTrainerExperienceInYearsInput): MessageOperationRequest<UpdateTrainerExperienceInYearsInput> {
    return new MessageOperationRequest<UpdateTrainerExperienceInYearsInput>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<UpdateTrainerExperienceInYearsInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerExperienceInYears",
        "PATCH",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateTrainerThumbnail(input: UpdateTrainerThumbnailInput): MessageOperationRequest<UpdateTrainerThumbnailInput> {
    return new MessageOperationRequest<UpdateTrainerThumbnailInput>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<UpdateTrainerThumbnailInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerThumbnail",
        "PATCH",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getTrainer(): RequestOperationRequest<object,Trainer> {
    return new RequestOperationRequest<object,Trainer>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<object,Trainer>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.GetTrainer",
        "GET",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateTrainerState(input: UpdateTrainerStateInput): MessageOperationRequest<UpdateTrainerStateInput> {
    return new MessageOperationRequest<UpdateTrainerStateInput>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<UpdateTrainerStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerState",
        "PATCH",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateTrainerSignature(input: UpdateTrainerSignatureInput): MessageOperationRequest<UpdateTrainerSignatureInput> {
    return new MessageOperationRequest<UpdateTrainerSignatureInput>(
      "PetKey.BackofficeFE.Client.TrainerManagment",
      new TransportOperation<UpdateTrainerSignatureInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerSignature",
        "PATCH",
        ["TrainerId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class HealthCheckItemManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Health.CreateHealthCheckItem\n  UsageId: PetKey.BackofficeFE.Client.HealthCheckItemManagement\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    healthCheckItemId?: Guid\n    name: string\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Health.GetAllHealthCheckItems\n  UsageId: PetKey.BackofficeFE.Client.HealthCheckItemManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = true)):\n    id: Guid\n    name: string\n    translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Health.DeleteHealthCheckItem\n  UsageId: PetKey.BackofficeFE.Client.HealthCheckItemManagement\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Health.UpdateHealthCheckItemName\n  UsageId: PetKey.BackofficeFE.Client.HealthCheckItemManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Health.UpdateHealthCheckItemState\n  UsageId: PetKey.BackofficeFE.Client.HealthCheckItemManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\n'
  }

  public static createHealthCheckItem(input: CreateHealthCheckItemInput): RequestOperationRequest<CreateHealthCheckItemInput,HealthCheckItem> {
    return new RequestOperationRequest<CreateHealthCheckItemInput,HealthCheckItem>(
      "PetKey.BackofficeFE.Client.HealthCheckItemManagement",
      new TransportOperation<CreateHealthCheckItemInput,HealthCheckItem>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Health.CreateHealthCheckItem",
        "CREATE",
        ["HealthCheckItemId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getAllHealthCheckItems(): RequestOperationRequest<object,HealthCheckItem[]> {
    return new RequestOperationRequest<object,HealthCheckItem[]>(
      "PetKey.BackofficeFE.Client.HealthCheckItemManagement",
      new TransportOperation<object,HealthCheckItem[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Health.GetAllHealthCheckItems",
        "GET",
        ["HealthCheckItemId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static deleteHealthCheckItem(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.HealthCheckItemManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Health.DeleteHealthCheckItem",
        "DELETE",
        ["HealthCheckItemId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateHealthCheckItemName(input: UpdateHealthCheckItemNameInput): MessageOperationRequest<UpdateHealthCheckItemNameInput> {
    return new MessageOperationRequest<UpdateHealthCheckItemNameInput>(
      "PetKey.BackofficeFE.Client.HealthCheckItemManagement",
      new TransportOperation<UpdateHealthCheckItemNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Health.UpdateHealthCheckItemName",
        "PATCH",
        ["HealthCheckItemId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateHealthCheckItemState(input: UpdateHealthCheckItemStateInput): MessageOperationRequest<UpdateHealthCheckItemStateInput> {
    return new MessageOperationRequest<UpdateHealthCheckItemStateInput>(
      "PetKey.BackofficeFE.Client.HealthCheckItemManagement",
      new TransportOperation<UpdateHealthCheckItemStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Health.UpdateHealthCheckItemState",
        "PATCH",
        ["HealthCheckItemId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class InsuranceProviderManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.CreateInsuranceProvider\n  UsageId: PetKey.BackofficeFE.Client.InsuranceProviderManagement\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    insuranceProviderId?: Guid\n    name: string\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.SearchInsuranceProvider\n  UsageId: PetKey.BackofficeFE.Client.InsuranceProviderManagement\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    query: string\n    limit: int\n    offset: int\n\n  Output(isArray = true)):\n    id: Guid\n    name: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.GetInsuranceProvider\n  UsageId: PetKey.BackofficeFE.Client.InsuranceProviderManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.DeleteInsuranceProvider\n  UsageId: PetKey.BackofficeFE.Client.InsuranceProviderManagement\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.UpdateInsuranceProviderName\n  UsageId: PetKey.BackofficeFE.Client.InsuranceProviderManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.UpdateInsuranceProviderState\n  UsageId: PetKey.BackofficeFE.Client.InsuranceProviderManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\n'
  }

  public static createInsuranceProvider(input: CreateInsuranceProviderInput): RequestOperationRequest<CreateInsuranceProviderInput,InsuranceProvider> {
    return new RequestOperationRequest<CreateInsuranceProviderInput,InsuranceProvider>(
      "PetKey.BackofficeFE.Client.InsuranceProviderManagement",
      new TransportOperation<CreateInsuranceProviderInput,InsuranceProvider>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.CreateInsuranceProvider",
        "CREATE",
        ["InsuranceProviderId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static searchInsuranceProvider(input: SearchInput): RequestOperationRequest<SearchInput,InsuranceProvider[]> {
    return new RequestOperationRequest<SearchInput,InsuranceProvider[]>(
      "PetKey.BackofficeFE.Client.InsuranceProviderManagement",
      new TransportOperation<SearchInput,InsuranceProvider[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.SearchInsuranceProvider",
        "SEARCH",
        ["InsuranceProviderId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getInsuranceProvider(): RequestOperationRequest<object,InsuranceProvider> {
    return new RequestOperationRequest<object,InsuranceProvider>(
      "PetKey.BackofficeFE.Client.InsuranceProviderManagement",
      new TransportOperation<object,InsuranceProvider>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.GetInsuranceProvider",
        "GET",
        ["InsuranceProviderId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static deleteInsuranceProvider(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.InsuranceProviderManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.DeleteInsuranceProvider",
        "DELETE",
        ["InsuranceProviderId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateInsuranceProviderName(input: UpdateInsuranceProviderNameInput): MessageOperationRequest<UpdateInsuranceProviderNameInput> {
    return new MessageOperationRequest<UpdateInsuranceProviderNameInput>(
      "PetKey.BackofficeFE.Client.InsuranceProviderManagement",
      new TransportOperation<UpdateInsuranceProviderNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.UpdateInsuranceProviderName",
        "PATCH",
        ["InsuranceProviderId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateInsuranceProviderState(input: UpdateInsuranceProviderStateInput): MessageOperationRequest<UpdateInsuranceProviderStateInput> {
    return new MessageOperationRequest<UpdateInsuranceProviderStateInput>(
      "PetKey.BackofficeFE.Client.InsuranceProviderManagement",
      new TransportOperation<UpdateInsuranceProviderStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.UpdateInsuranceProviderState",
        "PATCH",
        ["InsuranceProviderId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class SportsManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Sports.CreateSport\n  UsageId: PetKey.BackofficeFE.Client.SportsManagement\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    sportId?: Guid\n    name: string\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Sports.SearchSport\n  UsageId: PetKey.BackofficeFE.Client.SportsManagement\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    query: string\n    limit: int\n    offset: int\n\n  Output(isArray = true)):\n    id: Guid\n    name: string\n    translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Sports.GetSport\n  UsageId: PetKey.BackofficeFE.Client.SportsManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    translationKey: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Sports.DeleteSport\n  UsageId: PetKey.BackofficeFE.Client.SportsManagement\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Sports.UpdateSportName\n  UsageId: PetKey.BackofficeFE.Client.SportsManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Sports.UpdateSportState\n  UsageId: PetKey.BackofficeFE.Client.SportsManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\n'
  }

  public static createSport(input: CreateSportInput): RequestOperationRequest<CreateSportInput,Sport> {
    return new RequestOperationRequest<CreateSportInput,Sport>(
      "PetKey.BackofficeFE.Client.SportsManagement",
      new TransportOperation<CreateSportInput,Sport>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.CreateSport",
        "CREATE",
        ["SportId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static searchSport(input: SearchInput): RequestOperationRequest<SearchInput,Sport[]> {
    return new RequestOperationRequest<SearchInput,Sport[]>(
      "PetKey.BackofficeFE.Client.SportsManagement",
      new TransportOperation<SearchInput,Sport[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.SearchSport",
        "SEARCH",
        ["SportId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getSport(): RequestOperationRequest<object,Sport> {
    return new RequestOperationRequest<object,Sport>(
      "PetKey.BackofficeFE.Client.SportsManagement",
      new TransportOperation<object,Sport>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.GetSport",
        "GET",
        ["SportId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static deleteSport(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.SportsManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.DeleteSport",
        "DELETE",
        ["SportId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateSportName(input: UpdateSportNameInput): MessageOperationRequest<UpdateSportNameInput> {
    return new MessageOperationRequest<UpdateSportNameInput>(
      "PetKey.BackofficeFE.Client.SportsManagement",
      new TransportOperation<UpdateSportNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.UpdateSportName",
        "PATCH",
        ["SportId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateSportState(input: UpdateSportStateInput): MessageOperationRequest<UpdateSportStateInput> {
    return new MessageOperationRequest<UpdateSportStateInput>(
      "PetKey.BackofficeFE.Client.SportsManagement",
      new TransportOperation<UpdateSportStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Sports.UpdateSportState",
        "PATCH",
        ["SportId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class PredefinedTaskManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.CreatePredefinedTask\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    predefinedTaskId?: Guid\n    name: string\n    # Valid values: daily, health, longterm\n    type: string\n\n  Output(isArray = false):\n    id: Guid\n    species[]:\n      speciesId: Guid\n      breedIds[]: Guid\n    # Valid values: daily, health, longterm\n    type: string\n    name: string\n    translationKey: string\n    iconName?: string\n    suggestedRRULE?: string\n    suggestedReminders[]:\n      offset: int\n      # Valid values: notification, email\n      medium[]: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.SearchPredefinedTask\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    query: string\n    limit: int\n    offset: int\n\n  Output(isArray = true)):\n    id: Guid\n    species[]:\n      speciesId: Guid\n      breedIds[]: Guid\n    # Valid values: daily, health, longterm\n    type: string\n    name: string\n    translationKey: string\n    iconName?: string\n    suggestedRRULE?: string\n    suggestedReminders[]:\n      offset: int\n      # Valid values: notification, email\n      medium[]: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.GetPredefinedTask\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = false):\n    id: Guid\n    species[]:\n      speciesId: Guid\n      breedIds[]: Guid\n    # Valid values: daily, health, longterm\n    type: string\n    name: string\n    translationKey: string\n    iconName?: string\n    suggestedRRULE?: string\n    suggestedReminders[]:\n      offset: int\n      # Valid values: notification, email\n      medium[]: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.DeletePredefinedTask\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskType\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: daily, health, longterm\n    type: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskName\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskIcon\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    icon?: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSuggestedRRULE\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    suggestedRRULE?: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.AddPredefinedTaskSpecies\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: ADD\n  Type: message\n  Input(isArray = false):\n    speciesId: Guid\n    breedId[]: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSpecies\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    speciesId: Guid\n    breedId[]: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.RemovePredefinedTaskSpecies\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: REMOVE\n  Type: message\n  Input(isArray = false):\n    speciesId: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskState\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\n'
  }

  public static createPredefinedTask(input: CreatePredefinedTaskInput): RequestOperationRequest<CreatePredefinedTaskInput,PredefinedTask> {
    return new RequestOperationRequest<CreatePredefinedTaskInput,PredefinedTask>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<CreatePredefinedTaskInput,PredefinedTask>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.CreatePredefinedTask",
        "CREATE",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static searchPredefinedTask(input: SearchInput): RequestOperationRequest<SearchInput,PredefinedTask[]> {
    return new RequestOperationRequest<SearchInput,PredefinedTask[]>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<SearchInput,PredefinedTask[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.SearchPredefinedTask",
        "SEARCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getPredefinedTask(): RequestOperationRequest<object,PredefinedTask> {
    return new RequestOperationRequest<object,PredefinedTask>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<object,PredefinedTask>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.GetPredefinedTask",
        "GET",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static deletePredefinedTask(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.DeletePredefinedTask",
        "DELETE",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updatePredefinedTaskType(input: UpdatePredefinedTaskTypeInput): MessageOperationRequest<UpdatePredefinedTaskTypeInput> {
    return new MessageOperationRequest<UpdatePredefinedTaskTypeInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<UpdatePredefinedTaskTypeInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskType",
        "PATCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updatePredefinedTaskName(input: UpdatePredefinedTaskNameInput): MessageOperationRequest<UpdatePredefinedTaskNameInput> {
    return new MessageOperationRequest<UpdatePredefinedTaskNameInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<UpdatePredefinedTaskNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskName",
        "PATCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updatePredefinedTaskIcon(input: UpdatePredefinedTaskIconInput): MessageOperationRequest<UpdatePredefinedTaskIconInput> {
    return new MessageOperationRequest<UpdatePredefinedTaskIconInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<UpdatePredefinedTaskIconInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskIcon",
        "PATCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updatePredefinedTaskSuggestedRRULE(input: UpdatePredefinedTaskSuggestedRRULEInput): MessageOperationRequest<UpdatePredefinedTaskSuggestedRRULEInput> {
    return new MessageOperationRequest<UpdatePredefinedTaskSuggestedRRULEInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<UpdatePredefinedTaskSuggestedRRULEInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSuggestedRRULE",
        "PATCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static addPredefinedTaskSpecies(input: AddPredefinedTaskSpeciesInput): MessageOperationRequest<AddPredefinedTaskSpeciesInput> {
    return new MessageOperationRequest<AddPredefinedTaskSpeciesInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<AddPredefinedTaskSpeciesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.AddPredefinedTaskSpecies",
        "ADD",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updatePredefinedTaskSpecies(input: UpdatePredefinedTaskSpeciesInput): MessageOperationRequest<UpdatePredefinedTaskSpeciesInput> {
    return new MessageOperationRequest<UpdatePredefinedTaskSpeciesInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<UpdatePredefinedTaskSpeciesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSpecies",
        "PATCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static removePredefinedTaskSpecies(input: RemovePredefinedTaskSpeciesInput): MessageOperationRequest<RemovePredefinedTaskSpeciesInput> {
    return new MessageOperationRequest<RemovePredefinedTaskSpeciesInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<RemovePredefinedTaskSpeciesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.RemovePredefinedTaskSpecies",
        "REMOVE",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updatePredefinedTaskState(input: UpdatePredefinedTaskStateInput): MessageOperationRequest<UpdatePredefinedTaskStateInput> {
    return new MessageOperationRequest<UpdatePredefinedTaskStateInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskManagement",
      new TransportOperation<UpdatePredefinedTaskStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskState",
        "PATCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class PredefinedTaskRRULAISuggest {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSuggestedRRULE\n  UsageId: PetKey.BackofficeFE.Client.PredefinedTaskRRULAISuggest\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    suggestedRRULE?: string\n\n  Output:\n    {}\n'
  }

  public static updatePredefinedTaskSuggestedRRULE(input: UpdatePredefinedTaskSuggestedRRULEInput): MessageOperationRequest<UpdatePredefinedTaskSuggestedRRULEInput> {
    return new MessageOperationRequest<UpdatePredefinedTaskSuggestedRRULEInput>(
      "PetKey.BackofficeFE.Client.PredefinedTaskRRULAISuggest",
      new TransportOperation<UpdatePredefinedTaskSuggestedRRULEInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSuggestedRRULE",
        "PATCH",
        ["PredefinedTaskId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class CourseManagment {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.SearchCourses\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    query: string\n    limit: int\n    offset: int\n    categoryFilter?: Guid\n\n  Output(isArray = true)):\n    courseId: Guid\n    name: string\n    description: string\n    lessonCount: int\n    courseCategoryIds[]: Guid\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.CreateCourse\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    courseId?: Guid\n    name: string\n    description?: string\n    trainerId?: Guid\n    # Valid values: person, pet\n    type: string\n    speciesId?: Guid\n    breedIds[]: Guid\n    thumbnailUrl?: string\n    videoUrl?: string\n    longDescription?: string\n    categories[]: Guid\n\n  Output(isArray = false):\n    id: Guid\n    type:\n      # Valid values: person, pet\n      type: string\n      speciesId?: Guid\n      breedIds[]: Guid\n    name: string\n    media:\n      thumbnail:\n        url: string\n      video:\n        url: string\n    details:\n      duration: int\n      description: string\n      trainerId?: Guid\n      longDescription: string\n      categories[]: Guid\n      sequentialCompletion: boolean\n    modules[]:\n      sortId: int\n      module:\n        id: Guid\n        name: string\n        description: string\n        lessons[]:\n          sortId: int\n          lesson:\n            id: Guid\n            name: string\n            media:\n              thumbnail:\n                url: string\n              video:\n                url: string\n            details:\n              description: string\n              longDescription: string\n              duration: int\n            material:\n              requirements[]:\n                sortId: int\n                requirement:\n                  id: Guid\n                  description: string\n              steps[]:\n                sortId: int\n                step:\n                  id: Guid\n                  name: string\n                  description: string\n                  thumbnail:\n                    url: string\n              questions[]:\n                sortId: int\n                question:\n                  id: Guid\n                  # Valid values: yesno, multiplechoice\n                  type: string\n                  question: string\n                  typeOptions:\n                    ifMultipleChoice[]: string\n                  validationOptions:\n                    ifYesNo: boolean\n                    ifMultipleChoice: int\n              minimumNumberOfCorrectAnswers: int\n              linkedCommands[]: Guid\n    paymentReference:\n      productId: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.DeleteCourse\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.GetCourse\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = false):\n    id: Guid\n    type:\n      # Valid values: person, pet\n      type: string\n      speciesId?: Guid\n      breedIds[]: Guid\n    name: string\n    media:\n      thumbnail:\n        url: string\n      video:\n        url: string\n    details:\n      duration: int\n      description: string\n      trainerId?: Guid\n      longDescription: string\n      categories[]: Guid\n      sequentialCompletion: boolean\n    modules[]:\n      sortId: int\n      module:\n        id: Guid\n        name: string\n        description: string\n        lessons[]:\n          sortId: int\n          lesson:\n            id: Guid\n            name: string\n            media:\n              thumbnail:\n                url: string\n              video:\n                url: string\n            details:\n              description: string\n              longDescription: string\n              duration: int\n            material:\n              requirements[]:\n                sortId: int\n                requirement:\n                  id: Guid\n                  description: string\n              steps[]:\n                sortId: int\n                step:\n                  id: Guid\n                  name: string\n                  description: string\n                  thumbnail:\n                    url: string\n              questions[]:\n                sortId: int\n                question:\n                  id: Guid\n                  # Valid values: yesno, multiplechoice\n                  type: string\n                  question: string\n                  typeOptions:\n                    ifMultipleChoice[]: string\n                  validationOptions:\n                    ifYesNo: boolean\n                    ifMultipleChoice: int\n              minimumNumberOfCorrectAnswers: int\n              linkedCommands[]: Guid\n    paymentReference:\n      productId: string\n    state:\n      # Valid values: draft, published\n      state: string\n      isDirty: boolean\n      lastPublishedAt?: DateTime\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseType\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: person, pet\n    type: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseSpeciesId\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    speciesId?: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseBreedIds\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    breedIds[]: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseName\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseThumbnailUrl\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    url: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseVideoUrl\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    url: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseDuration\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    duration: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseDescription\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseTrainerId\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    trainerId: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseLongDescription\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    longDescription: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseCategories\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    categories[]: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseSequentialCompletion\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    sequentialCompletion: boolean\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCoursePaymentProductId\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    productId: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.AddModule\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: ADD\n  Type: message\n  Input(isArray = false):\n    moduleId?: Guid\n    name: string\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.RemoveModule\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: REMOVE\n  Type: message\n  Input(isArray = false):\n    moduleId: Guid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateModuleName\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    moduleId: Guid\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateModuleDescription\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    moduleId: Guid\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateLesson\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: CREATE\n  Type: request\n  Input(isArray = false):\n    moduleId: Guid\n    lessonId?: Guid\n    name: string\n    thumbnailUrl?: string\n    videoUrl?: string\n    description: string\n    longDescription?: string\n    duration?: int\n\n  Output(isArray = false):\n    id: Guid\n    name: string\n    media:\n      thumbnail:\n        url: string\n      video:\n        url: string\n    details:\n      description: string\n      longDescription: string\n      duration: int\n    material:\n      requirements[]:\n        sortId: int\n        requirement:\n          id: Guid\n          description: string\n      steps[]:\n        sortId: int\n        step:\n          id: Guid\n          name: string\n          description: string\n          thumbnail:\n            url: string\n      questions[]:\n        sortId: int\n        question:\n          id: Guid\n          # Valid values: yesno, multiplechoice\n          type: string\n          question: string\n          typeOptions:\n            ifMultipleChoice[]: string\n          validationOptions:\n            ifYesNo: boolean\n            ifMultipleChoice: int\n      minimumNumberOfCorrectAnswers: int\n      linkedCommands[]: Guid\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteLesson\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: DELETE\n  Type: message\n  Input:\n    {}\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonName\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    name: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonThumbnailUrl\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    url: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonVideoUrl\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    url: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonDescription\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonLongDescription\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    longDescription: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonDuration\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    duration: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialRequirement\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: ADD\n  Type: message\n  Input(isArray = false):\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialRequirement\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: UPDATE\n  Type: message\n  Input(isArray = false):\n    id: Guid\n    description: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialRequirement\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: REMOVE\n  Type: message\n  Input(isArray = false):\nGuid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialStep\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: ADD\n  Type: message\n  Input(isArray = false):\n    name: string\n    description: string\n    thumbnail:\n      url: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialStep\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: UPDATE\n  Type: message\n  Input(isArray = false):\n    id: Guid\n    name: string\n    description: string\n    thumbnail:\n      url: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialStep\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: REMOVE\n  Type: message\n  Input(isArray = false):\nGuid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.AddCommand\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: ADD\n  Type: message\n  Input(isArray = false):\nGuid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.RemoveCommand\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: REMOVE\n  Type: message\n  Input(isArray = false):\nGuid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialQuestion\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: ADD\n  Type: message\n  Input(isArray = false):\n    # Valid values: yesno, multiplechoice\n    type: string\n    question: string\n    typeOptions:\n      ifMultipleChoice[]: string\n    validationOptions:\n      ifYesNo: boolean\n      ifMultipleChoice: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialQuestion\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: UPDATE\n  Type: message\n  Input(isArray = false):\n    id: Guid\n    # Valid values: yesno, multiplechoice\n    type: string\n    question: string\n    typeOptions:\n      ifMultipleChoice[]: string\n    validationOptions:\n      ifYesNo: boolean\n      ifMultipleChoice: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialQuestion\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: REMOVE\n  Type: message\n  Input(isArray = false):\nGuid\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonMinimumNumberOfCorrectAnswers\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    minimumNumberOfCorrectAnswers: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialRequirements\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = true)):\n    id: Guid\n    moveInstruction:\n      # Valid values: up, down, top, bottom, toposition\n      moveDirection: string\n      position?: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialSteps\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = true)):\n    id: Guid\n    moveInstruction:\n      # Valid values: up, down, top, bottom, toposition\n      moveDirection: string\n      position?: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialQuestions\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = true)):\n    id: Guid\n    moveInstruction:\n      # Valid values: up, down, top, bottom, toposition\n      moveDirection: string\n      position?: int\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseState\n  UsageId: PetKey.BackofficeFE.Client.CourseManagment\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    # Valid values: publish, unpublish, revert\n    stateTransition: string\n\n  Output:\n    {}\n'
  }

  public static searchCourses(input: SearchCoursesInput): RequestOperationRequest<SearchCoursesInput,SearchCoursesOutput[]> {
    return new RequestOperationRequest<SearchCoursesInput,SearchCoursesOutput[]>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<SearchCoursesInput,SearchCoursesOutput[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.SearchCourses",
        "SEARCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createCourse(input: CreateCourseInput): RequestOperationRequest<CreateCourseInput,Course> {
    return new RequestOperationRequest<CreateCourseInput,Course>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<CreateCourseInput,Course>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.CreateCourse",
        "CREATE",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static deleteCourse(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.DeleteCourse",
        "DELETE",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static getCourse(): RequestOperationRequest<object,Course> {
    return new RequestOperationRequest<object,Course>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<object,Course>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.GetCourse",
        "GET",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateCourseType(input: UpdateCourseTypeInput): MessageOperationRequest<UpdateCourseTypeInput> {
    return new MessageOperationRequest<UpdateCourseTypeInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseTypeInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseType",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseSpeciesId(input: UpdateCourseSpeciesIdInput): MessageOperationRequest<UpdateCourseSpeciesIdInput> {
    return new MessageOperationRequest<UpdateCourseSpeciesIdInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseSpeciesIdInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseSpeciesId",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseBreedIds(input: UpdateCourseBreedIdsInput): MessageOperationRequest<UpdateCourseBreedIdsInput> {
    return new MessageOperationRequest<UpdateCourseBreedIdsInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseBreedIdsInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseBreedIds",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseName(input: UpdateCourseNameInput): MessageOperationRequest<UpdateCourseNameInput> {
    return new MessageOperationRequest<UpdateCourseNameInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseName",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseThumbnailUrl(input: UpdateCourseThumbnailUrlInput): MessageOperationRequest<UpdateCourseThumbnailUrlInput> {
    return new MessageOperationRequest<UpdateCourseThumbnailUrlInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseThumbnailUrlInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseThumbnailUrl",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseVideoUrl(input: UpdateCourseVideoUrlInput): MessageOperationRequest<UpdateCourseVideoUrlInput> {
    return new MessageOperationRequest<UpdateCourseVideoUrlInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseVideoUrlInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseVideoUrl",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseDuration(input: UpdateCourseDurationInput): MessageOperationRequest<UpdateCourseDurationInput> {
    return new MessageOperationRequest<UpdateCourseDurationInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseDurationInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseDuration",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseDescription(input: UpdateCourseDescriptionInput): MessageOperationRequest<UpdateCourseDescriptionInput> {
    return new MessageOperationRequest<UpdateCourseDescriptionInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseDescription",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseTrainerId(input: UpdateCourseTrainerIdInput): MessageOperationRequest<UpdateCourseTrainerIdInput> {
    return new MessageOperationRequest<UpdateCourseTrainerIdInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseTrainerIdInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseTrainerId",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseLongDescription(input: UpdateCourseLongDescriptionInput): MessageOperationRequest<UpdateCourseLongDescriptionInput> {
    return new MessageOperationRequest<UpdateCourseLongDescriptionInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseLongDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseLongDescription",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseCategories(input: UpdateCourseCategoriesInput): MessageOperationRequest<UpdateCourseCategoriesInput> {
    return new MessageOperationRequest<UpdateCourseCategoriesInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseCategoriesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseCategories",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseSequentialCompletion(input: UpdateCourseSequentialCompletionInput): MessageOperationRequest<UpdateCourseSequentialCompletionInput> {
    return new MessageOperationRequest<UpdateCourseSequentialCompletionInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseSequentialCompletionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseSequentialCompletion",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCoursePaymentProductId(input: UpdateCoursePaymentProductIdInput): MessageOperationRequest<UpdateCoursePaymentProductIdInput> {
    return new MessageOperationRequest<UpdateCoursePaymentProductIdInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCoursePaymentProductIdInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCoursePaymentProductId",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static addModule(input: AddModuleInput): MessageOperationRequest<AddModuleInput> {
    return new MessageOperationRequest<AddModuleInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<AddModuleInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.AddModule",
        "ADD",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static removeModule(input: RemoveModuleInput): MessageOperationRequest<RemoveModuleInput> {
    return new MessageOperationRequest<RemoveModuleInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<RemoveModuleInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.RemoveModule",
        "REMOVE",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateModuleName(input: UpdateModuleNameInput): MessageOperationRequest<UpdateModuleNameInput> {
    return new MessageOperationRequest<UpdateModuleNameInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateModuleNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateModuleName",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateModuleDescription(input: UpdateModuleDescriptionInput): MessageOperationRequest<UpdateModuleDescriptionInput> {
    return new MessageOperationRequest<UpdateModuleDescriptionInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateModuleDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateModuleDescription",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createLesson(input: CreateLessonInput): RequestOperationRequest<CreateLessonInput,Lesson> {
    return new RequestOperationRequest<CreateLessonInput,Lesson>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<CreateLessonInput,Lesson>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateLesson",
        "CREATE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static deleteLesson(): MessageOperationRequest<object> {
    return new MessageOperationRequest<object>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<object,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteLesson",
        "DELETE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static updateLessonName(input: UpdateLessonNameInput): MessageOperationRequest<UpdateLessonNameInput> {
    return new MessageOperationRequest<UpdateLessonNameInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateLessonNameInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonName",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateLessonThumbnailUrl(input: UpdateLessonThumbnailUrlInput): MessageOperationRequest<UpdateLessonThumbnailUrlInput> {
    return new MessageOperationRequest<UpdateLessonThumbnailUrlInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateLessonThumbnailUrlInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonThumbnailUrl",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateLessonVideoUrl(input: UpdateLessonVideoUrlInput): MessageOperationRequest<UpdateLessonVideoUrlInput> {
    return new MessageOperationRequest<UpdateLessonVideoUrlInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateLessonVideoUrlInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonVideoUrl",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateLessonDescription(input: UpdateLessonDescriptionInput): MessageOperationRequest<UpdateLessonDescriptionInput> {
    return new MessageOperationRequest<UpdateLessonDescriptionInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateLessonDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonDescription",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateLessonLongDescription(input: UpdateLessonLongDescriptionInput): MessageOperationRequest<UpdateLessonLongDescriptionInput> {
    return new MessageOperationRequest<UpdateLessonLongDescriptionInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateLessonLongDescriptionInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonLongDescription",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateLessonDuration(input: UpdateLessonDurationInput): MessageOperationRequest<UpdateLessonDurationInput> {
    return new MessageOperationRequest<UpdateLessonDurationInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateLessonDurationInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonDuration",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createMaterialRequirement(input: MaterialRequirementValues): MessageOperationRequest<MaterialRequirementValues> {
    return new MessageOperationRequest<MaterialRequirementValues>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MaterialRequirementValues,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialRequirement",
        "ADD",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateMaterialRequirement(input: MaterialRequirement): MessageOperationRequest<MaterialRequirement> {
    return new MessageOperationRequest<MaterialRequirement>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MaterialRequirement,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialRequirement",
        "UPDATE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static deleteMaterialRequirement(input: string): MessageOperationRequest<string> {
    return new MessageOperationRequest<string>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<string,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialRequirement",
        "REMOVE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createMaterialStep(input: MaterialStepValues): MessageOperationRequest<MaterialStepValues> {
    return new MessageOperationRequest<MaterialStepValues>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MaterialStepValues,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialStep",
        "ADD",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateMaterialStep(input: MaterialStep): MessageOperationRequest<MaterialStep> {
    return new MessageOperationRequest<MaterialStep>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MaterialStep,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialStep",
        "UPDATE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static deleteMaterialStep(input: string): MessageOperationRequest<string> {
    return new MessageOperationRequest<string>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<string,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialStep",
        "REMOVE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static addCommand(input: string): MessageOperationRequest<string> {
    return new MessageOperationRequest<string>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<string,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.AddCommand",
        "ADD",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static removeCommand(input: string): MessageOperationRequest<string> {
    return new MessageOperationRequest<string>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<string,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.RemoveCommand",
        "REMOVE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createMaterialQuestion(input: MaterialQuestionValues): MessageOperationRequest<MaterialQuestionValues> {
    return new MessageOperationRequest<MaterialQuestionValues>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MaterialQuestionValues,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.CreateMaterialQuestion",
        "ADD",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateMaterialQuestion(input: MaterialQuestion): MessageOperationRequest<MaterialQuestion> {
    return new MessageOperationRequest<MaterialQuestion>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MaterialQuestion,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateMaterialQuestion",
        "UPDATE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static deleteMaterialQuestion(input: string): MessageOperationRequest<string> {
    return new MessageOperationRequest<string>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<string,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.DeleteMaterialQuestion",
        "REMOVE",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateLessonMinimumNumberOfCorrectAnswers(input: UpdateLessonMinimumNumberOfCorrectAnswersInput): MessageOperationRequest<UpdateLessonMinimumNumberOfCorrectAnswersInput> {
    return new MessageOperationRequest<UpdateLessonMinimumNumberOfCorrectAnswersInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateLessonMinimumNumberOfCorrectAnswersInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.UpdateLessonMinimumNumberOfCorrectAnswers",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static moveMaterialRequirements(input: MoveMaterialRequirementsInput[]): MessageOperationRequest<MoveMaterialRequirementsInput[]> {
    return new MessageOperationRequest<MoveMaterialRequirementsInput[]>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MoveMaterialRequirementsInput[],object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialRequirements",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static moveMaterialSteps(input: MoveMaterialStepsInput[]): MessageOperationRequest<MoveMaterialStepsInput[]> {
    return new MessageOperationRequest<MoveMaterialStepsInput[]>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MoveMaterialStepsInput[],object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialSteps",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static moveMaterialQuestions(input: MoveMaterialQuestionsInput[]): MessageOperationRequest<MoveMaterialQuestionsInput[]> {
    return new MessageOperationRequest<MoveMaterialQuestionsInput[]>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<MoveMaterialQuestionsInput[],object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.Lessons.MoveMaterialQuestions",
        "PATCH",
        ["LessonId", "CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static updateCourseState(input: UpdateCourseStateInput): MessageOperationRequest<UpdateCourseStateInput> {
    return new MessageOperationRequest<UpdateCourseStateInput>(
      "PetKey.BackofficeFE.Client.CourseManagment",
      new TransportOperation<UpdateCourseStateInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseState",
        "PATCH",
        ["CourseId"],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

export class TranslationManagement {
  public static toAgentInstructions(): string {
    return 'Operation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.SearchTranslationKeys\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: SEARCH\n  Type: request\n  Input(isArray = false):\n    searchInput:\n      query: string\n      limit: int\n      offset: int\n    language1Id: string\n    language2Id: string\n    onlyMissingForLang2: boolean\n    # Valid values: all, keyonly, keyandlang1, keyandlang2\n    searchType: string\n    # Valid values: draft, published\n    stateType?: string\n\n  Output(isArray = false):\n    language1: string\n    language2: string\n    keys[]:\n      key: string\n      value1: string\n      value2: string\n      lastPublishedAt?: DateTime\n      publishedValue2?: string\n      publishedValue1?: string\n      # Valid values: draft, published\n      stateType: string\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PatchTranslation\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    key: string\n    language1Value:\n      languageId: string\n      value: string\n    language2Value:\n      languageId: string\n      value: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.CreateTranslationKey\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: CREATE\n  Type: message\n  Input(isArray = false):\n    key: string\n    language1Value:\n      languageId: string\n      value: string\n    language2Value:\n      languageId: string\n      value: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.GetLanguages\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: GET\n  Type: request\n  Input:\n    {}\n\n  Output(isArray = true)):\n    id: string\n    name: string\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.DeleteTranslationKey\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: DELETE\n  Type: message\n  Input(isArray = false):\nstring\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PatchManyTranslations\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    language1: string\n    language2: string\n    keys[]:\n      key: string\n      value1: string\n      value2: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.CreateManyTranslationKeys\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: CREATE\n  Type: message\n  Input(isArray = false):\n    language1: string\n    language2: string\n    keys[]:\n      key: string\n      value1: string\n      value2: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PublishChanges\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    languages[]?: string\n    keys[]: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.RevertChanges\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    languages[]?: string\n    keys[]: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PublishAllChanges\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    languages[]?: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.RevertAllChanges\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: PATCH\n  Type: message\n  Input(isArray = false):\n    languages[]?: string\n\n  Output:\n    {}\nOperation id: PetKey.Main.Model.1_0_Initial.Backoffice.Translations.GetLanguageFiles\n  UsageId: PetKey.BackofficeFE.Client.TranslationManagement\n  Verb: GET\n  Type: request\n  Input(isArray = false):\n    languages[]: string\n    onlyPublished: boolean\n\n  Output(isArray = true)):\n    language: string\n    jsonContents: string\n'
  }

  public static searchTranslationKeys(input: SearchTranslationKeysInput): RequestOperationRequest<SearchTranslationKeysInput,SearchTranslationKeysOutput> {
    return new RequestOperationRequest<SearchTranslationKeysInput,SearchTranslationKeysOutput>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<SearchTranslationKeysInput,SearchTranslationKeysOutput>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.SearchTranslationKeys",
        "SEARCH",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static patchTranslation(input: TranslationKeyPair): MessageOperationRequest<TranslationKeyPair> {
    return new MessageOperationRequest<TranslationKeyPair>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<TranslationKeyPair,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PatchTranslation",
        "PATCH",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createTranslationKey(input: TranslationKeyPair): MessageOperationRequest<TranslationKeyPair> {
    return new MessageOperationRequest<TranslationKeyPair>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<TranslationKeyPair,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.CreateTranslationKey",
        "CREATE",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getLanguages(): RequestOperationRequest<object,Language[]> {
    return new RequestOperationRequest<object,Language[]>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<object,Language[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.GetLanguages",
        "GET",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      {}
    )
  }

  public static deleteTranslationKey(input: string): MessageOperationRequest<string> {
    return new MessageOperationRequest<string>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<string,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.DeleteTranslationKey",
        "DELETE",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static patchManyTranslations(input: MultipleTranslationKeyPairs): MessageOperationRequest<MultipleTranslationKeyPairs> {
    return new MessageOperationRequest<MultipleTranslationKeyPairs>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<MultipleTranslationKeyPairs,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PatchManyTranslations",
        "PATCH",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static createManyTranslationKeys(input: MultipleTranslationKeyPairs): MessageOperationRequest<MultipleTranslationKeyPairs> {
    return new MessageOperationRequest<MultipleTranslationKeyPairs>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<MultipleTranslationKeyPairs,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.CreateManyTranslationKeys",
        "CREATE",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static publishChanges(input: PublishChangesInput): MessageOperationRequest<PublishChangesInput> {
    return new MessageOperationRequest<PublishChangesInput>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<PublishChangesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PublishChanges",
        "PATCH",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static revertChanges(input: RevertChangesInput): MessageOperationRequest<RevertChangesInput> {
    return new MessageOperationRequest<RevertChangesInput>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<RevertChangesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.RevertChanges",
        "PATCH",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static publishAllChanges(input: PublishAllChangesInput): MessageOperationRequest<PublishAllChangesInput> {
    return new MessageOperationRequest<PublishAllChangesInput>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<PublishAllChangesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PublishAllChanges",
        "PATCH",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static revertAllChanges(input: RevertAllChangesInput): MessageOperationRequest<RevertAllChangesInput> {
    return new MessageOperationRequest<RevertAllChangesInput>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<RevertAllChangesInput,object>(
        "message",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.RevertAllChanges",
        "PATCH",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

  public static getLanguageFiles(input: GetLanguageFilesInput): RequestOperationRequest<GetLanguageFilesInput,GetLanguageFilesOutput[]> {
    return new RequestOperationRequest<GetLanguageFilesInput,GetLanguageFilesOutput[]>(
      "PetKey.BackofficeFE.Client.TranslationManagement",
      new TransportOperation<GetLanguageFilesInput,GetLanguageFilesOutput[]>(
        "request",
        "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.GetLanguageFiles",
        "GET",
        [],
        {
          requiresTenant: true,
          characterSetup: {
            performer: undefined,
            responsible: undefined,
            subject: undefined
          }
        }
      ),
      input
    )
  }

}

